import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount/ScrollToTopOnMount';
import BackToTopBtn from '../../components/BackToTopBtn/BackToTopBtn';

function DefaultLayout({ children }) {
    return (
        <>
            <Header />
            <ScrollToTopOnMount />
            { children }
            <BackToTopBtn />
            <Footer />
        </>
    )
}

export default DefaultLayout;